//
// Action Types
//

export const SET_MOBILE_SIDEBAR_STATE = 'pro/layout/SET_MOBILE_SIDEBAR_STATE';
export const SET_SIDENAV_STATE = 'pro/layout/SET_SIDENAV_STATE';
export const SET_NOTIFICATIONS_SIDEBAR_STATE =
  'pro/layout/SET_NOTIFICATIONS_SIDEBAR_STATE';

//
// Action Creators
//

export const setMobileSidebarState = expanded => ({
  type: SET_MOBILE_SIDEBAR_STATE,
  expanded,
});

export const setSideNavState = expanded => ({
  type: SET_SIDENAV_STATE,
  expanded,
});

export const setNotificationsSidebarState = expanded => ({
  type: SET_NOTIFICATIONS_SIDEBAR_STATE,
  expanded,
});

//
// Thunks
//

export const mobileSidebarToggle = () => (dispatch, getState) => {
  const { mobileSidebarExpanded } = getState().pro.layout;

  if (mobileSidebarExpanded) {
    dispatch(setMobileSidebarState(false));
  } else {
    dispatch(setMobileSidebarState(true));
  }
};

export const sideNavToggle = () => (dispatch, getState) => {
  const { sideNavExpanded } = getState().pro.layout;

  if (sideNavExpanded) {
    dispatch(setSideNavState(false));
  } else {
    dispatch(setSideNavState(true));
  }
};

export const notificationsSidebarToggle = () => (dispatch, getState) => {
  const { notificationsSidebarExpanded } = getState().pro.layout;

  if (notificationsSidebarExpanded) {
    dispatch(setNotificationsSidebarState(false));
  } else {
    dispatch(setNotificationsSidebarState(true));
  }
};
